import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import io from "socket.io-client";
import location from "../../../images/location.png";
//https://riderSocket.goone.club
var socket = io.connect("http://3.6.92.49:5050", {
  transports: ["websocket"],

});
function RiderMapView() {
  var L = window.L;
  var myIcon = L.icon({
    iconUrl: location,
    iconSize: [20, 35],
    iconAnchor: [22, 94],
    popupAnchor: [-3, -76],
    shadowSize: [68, 95],
    shadowAnchor: [22, 94],
  });
  const [riderDetails, setRiderDetails] = useState([]);
  const [vehicleSearch, setVehicleSearch] = useState([]);
  const [searchItem, setSearchItem] = useState("");

  const VehicleTypes = [
    "All vehicle",
    "Auto",
    "SUV/MUV",
    "Sedan",
    "Hatch Back",
    "Tata Ace",
    "PickUp 8ft",
    "Tata 407",
  ];

  useEffect(() => {
    socket.on("admin-rider-lat-lng", (data) => {
      setRiderDetails(data);
      setVehicleSearch(data);
    });
  }, []);

  function searchVehicleType(vehicle) {
    setSearchItem(vehicle);
    if (vehicle === "All") {
      setRiderDetails(vehicleSearch);
    } else {
      let vig = [];
      vehicleSearch.map((val) => {
        if (val.RiderVehicleType.name === vehicle) {
          vig.push(val);
        }
      });

      setRiderDetails(vig);
    }
  }
  return (
    <>
      <select
        style={{ position: "fixed", marginTop: 400 }}
        className="form- col-sm-3 text-primary p-2"
        id="val-skill"
        name="val-skill"
        placeholder="Select Search Item"
        defaultValue={searchItem}
        onChange={(event) => {
          searchVehicleType(event.target.value);
        }}
      >
        {VehicleTypes &&
          VehicleTypes.map((val) => <option value={val}>{val}</option>)}
         
      </select>
     
      <MapContainer
        style={{
          height: window.innerHeight / 1.6,
          width: window.innerWidth / 1.4,
          position: "fixed",
        }}
        center={[12.914125, 77.642114]}
        zoom={10}
        scrollWheelZoom={true}
      >
      <TileLayer
        url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        maxZoom={21}
        minZoom={4}
        minZoomIsDrawing={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
        {riderDetails &&
          riderDetails.map((val) => {
            return (
             <>
             {val.RiderCurrentLat_Lng &&(
               <Marker
               icon={myIcon}
               position={[
                 val.RiderCurrentLat_Lng.lat,
                 val.RiderCurrentLat_Lng.lng,
               ]}
             >
               <Popup>
                 {val.riderFirstName} {val.riderLastName}
                 <br />
                 {val.RiderVehicleType.name}
               </Popup>
             </Marker>
             )}
             </>
            );
          })}
      </MapContainer>
    </>
  );
}

export default RiderMapView;
